import {Redirect} from "react-router-dom";
import {RouterPaths} from "../../app/appConstants";
import {generatePath, matchPath, Route, Switch, useLocation, useParams} from "react-router";
import React from "react";
import {OnboardingWelcomePage} from "./OnboardingWelcomePage";
import {OnboardingCongratulationsPage} from "./OnboardingCongratulations/OnboardingCongratulationsPage";
import {OnboardingTutorial} from "./OnboardingTutorial/OnboardingTutorial";
import PageNotFound from "../../app/PageNotFound";

export const OnboardingRoute = () => {
    const location = useLocation();
    const {attempt} = useParams();

    if (matchPath(location.pathname, {path: RouterPaths.onboarding, exact: true})) {
        if (attempt === 'initial') {
            return <Redirect to={RouterPaths.onboardingWelcome}/>
        } else {
            return <Redirect to={generatePath(RouterPaths.onboardingTutorial, {attempt: 'repeated'})}/>
        }
    }
    return (
            <Switch>
                <Route exact path={RouterPaths.onboardingCongratulations} component={OnboardingCongratulationsPage}/>
                <Route path={RouterPaths.onboardingTutorial} component={OnboardingTutorial}/>
                <Route exact path={RouterPaths.onboardingWelcome} component={OnboardingWelcomePage}/>
                <Route path="**" component={PageNotFound}/>
            </Switch>
    )
}
